import { NgModule } from '@angular/core';
import { PrerenderService } from '@df/browser/storage/prerender/prerender.service';
import { SsrService } from '@df/universal/client/ssr.service';
import { SsrShortcutsService } from './ssr-shortcuts.service';

@NgModule({
    providers: [{ provide: PrerenderService, useExisting: SsrService }, SsrShortcutsService]
})
export class DfSsrModule {
    constructor(resourceTransferService: SsrService, ssrShortcutsService: SsrShortcutsService) {
        // set new values for client state
        resourceTransferService.init();

        ssrShortcutsService.appInitializer();
    }
}
